import React from 'react';
import PropTypes from 'prop-types';

import StyledAppWrapper from '@common/components/AppWrapper';
import CheckoutHeader from '@common/components/CheckoutHeader';
import { useIsMinimalStyle } from '@common/contexts/MinimalStyleContext';

const CheckoutLayout = ({ children, property = null }) => {
  const isMinimalStyle = useIsMinimalStyle();

  return (
    <StyledAppWrapper>
      {!isMinimalStyle && <CheckoutHeader logo={property.logo} name={property.name} />}
      {children}
    </StyledAppWrapper>
  );
};

CheckoutLayout.propTypes = {
  property: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    defaultLanguage: PropTypes.string,
    logo: PropTypes.object,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    websiteUrl: PropTypes.string,
    headerFont: PropTypes.string,
    bodyFont: PropTypes.string,
    isRoomsIntegrated: PropTypes.bool,
    isTablesIntegrated: PropTypes.bool,
    isSpaIntegrated: PropTypes.bool,
    additionalLanguages: PropTypes.arrayOf(PropTypes.string),
  }),
  journeyData: PropTypes.shape({
    fromDate: PropTypes.object,
    toDate: PropTypes.object,
    adults: PropTypes.number,
    children: PropTypes.number,
  }),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default CheckoutLayout;
